import { LOCALIZATION_OPTIONS } from '../../Localization/Constants';

export const actionTypes = {
  SET_LANGUAGE: 'SET_LANGUAGE',
};

const SELECTED_LOCALIZE_STORAGE_KEY = 'SELECTED_LOCALIZE';

const initialState = {
  selectedLanguage: JSON.parse(localStorage.getItem(SELECTED_LOCALIZE_STORAGE_KEY)) || LOCALIZATION_OPTIONS[0],
};

export default function localizeReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.SET_LANGUAGE: {
      localStorage.setItem(SELECTED_LOCALIZE_STORAGE_KEY, JSON.stringify(action.payload));
      return { ...state, selectedLanguage: action.payload };
    }
    default:
      return state;
  }
}
